import React from 'react';
import classnames from 'classnames';

import { H, P } from '@xingternal/malt-typography';

import styles from './Typography.css';

export const CustomH = ({ children, className, ...rest }) => (
  <H
    level={2}
    levelConfined={1}
    levelWide={1}
    className={classnames(styles.marginBottomXL, className)}
    {...rest}
  >
    {children}
  </H>
);

export const CustomP = ({ children, className, noMargin, ...rest }) => (
  <P
    className={classnames({ [styles.marginBottomXL]: !noMargin }, className)}
    noMargin={noMargin}
    {...rest}
  >
    {children}
  </P>
);
